<template>
  <section class="query--data">
    <div :class="{ 'query--data__bd': true, flex: !!fetch, 'flex-col': !!fetch }">
      <div :class="{ 'bd--table': !!fetch }">
        <div :class="{ 'bd-inner': !!fetch }">
          <el-table
            v-loading="list.ing"
            :height="height"
            border
            :header-cell-style="{ background: '#f3f4f9', color: '#333' }"
            :data="fetch ? list.model : data"
            :row-style="getRowStyle"
            :default-sort="sortProp"
            header-cell-class-name="f14 lh-22 text-color-grey4"
            cell-class-name="f14 lh-18 text-color-black2"
            @selection-change="list.selections = arguments[ 0 ], $emit('selected', !arguments[ 0 ].length)">
            <el-table-column
              v-if="isMultiple"
              fixed="left"
              type="selection"
              :selectable='selectEnable'
              width="55">
            </el-table-column>
            <template v-for="ele in computedListHeads">
              <template v-if="!('invisible' in ele && ele.invisible)">
                <el-table-column v-if="ele.slotName" :min-width="140" :key="ele.slotName" show-overflow-tooltip :label="ele.label" v-bind="ele.elProps">
                  <template slot-scope="prop">
                    <slot :name="ele.slotName" :data="{
                      ...prop.row,
                      $index: prop.$index
                    }"></slot>
                  </template>
                </el-table-column>
                <el-table-column v-else :key="ele.prop" :min-width="140" :label="ele.label"  show-overflow-tooltip :prop="ele.prop" v-bind="ele.elProps"></el-table-column>
              </template>
            </template>
            <div slot="empty" style="height: 200px;">暂无数据</div>
          </el-table>
        </div>
      </div>
      <div v-if="isPag" class="bd--pag">
        <el-pagination
          class="d-ib"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          :page-sizes="page.sizes"
          :page-size="page.size"
          :current-page="page.num"
          @current-change="page.num = arguments[ 0 ], _query()"
          @size-change="page.size = arguments[ 0 ], _query()">
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .query--data__bd {
    height: 100%;
    background-color: #fff;
  }
  .bd--table {
    flex: 1 0 auto;
    position: relative;
  }
  .bd-inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
  .bd--pag {
    flex: 0 0 auto;
    text-align: right;
    padding: 0 12px 24px 0;
    margin-top: 20px;
  }
</style>

<script>
import { getModelToOption } from '@/utils/env';

export default {
  name: 'UiQueryData',

  props: {
    // 加载时自动加载
    autoFetch: {
      type: Boolean,
      default: true
    },
    listHeads: {
      type: Array,
      required: true
    },
    fetch: Function,
    data: Array,
    isPag: {
      type: Boolean,
      default: () => true
    },
    isMultiple: {
      type: Boolean,
      default: () => false
    },
    selectEnable: {
      type: Function,
      default: () => {
        return true
      }
    },
    height: {
      type: [String, Number],
      default: '100%'
    },
    sortProp: Object
  },
  computed: {
    computedListHeads () {
      let heads = []
      // invisible true 不可见
      this.listHeads.forEach(item => {
        if (!(typeof item.invisible !== 'undefined' && item.invisible )) {
          heads.push(item)
        }
      })
      return heads
    }
  },

  data() {
    const data = {
      filter: {},
      list: {
        model: [],
        selections: [],
        ing: false
      },
      page: {
        num: 1,
        size: 50,
        sizes: [ 10, 20, 30, 50, 100 ],
        total: 0
      }
    };

    return data;
  },

  methods: {
    getRowStyle({ rowIndex }) {
      if (!(rowIndex % 2)) {
        return {
          background: '#fff'
        };
      }
      return {
        background: '#f3f4f9'
      };
    },

    handleQuery() {
      this.page.num = 1;
      this.filter.value = { ...this.filter.model };
      this._query();
    },
    getListData () {
      return this.fetch ? this.list.model : this.data
    },
    _query() {
      let fetchParams = {
        pageIndex: this.page.num,
        pageSize: this.page.size
      }
      if (this.filter) {
        fetchParams = { ...fetchParams, ...this.filter.value };
      }
      this.list.ing = true;
      this.list.model = []
      this
        .fetch(fetchParams)
        .then(data => {
          if (Array.isArray(data)) {
            this.list.model = [...data]
            this.page.total = data.length
          } else {
            let { records, total } = data || { records: [], total: 0 };
            this.list.model = records;
            this.page.total = total;
            this.$emit('total', total)
          }
        })
        .finally(() => this.list.ing = false);
    }
  },

  created() {
    // 和后端交互的table
    if (this.fetch && this.autoFetch) {
      this.handleQuery();
    }
  }
};
</script>
